/* eslint-disable no-useless-escape */
// RegEx
export const ONLY_NUMBER = /^[0-9]*$/
export const EMAIL =
  /^\s*(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*$/
export const PASSWORD = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-])/
export const NO_SPACE = /^\S*$/
export const NO_SPECIAL_CHARACTER = /^[A-Za-z0-9 ]+$/
export const NUMBER1TO10 = /^[1-9][0-9]?$|^100$/
export const URL_REGEX =
  /(([\w]+:)?\/\/)?(([\d\w]|%[a-fA-f\d]{2,2})+(:([\d\w]|%[a-fA-f\d]{2,2})+)?@)?([\d\w][-\d\w]{0,253}[\d\w]\.)+[\w]{2,63}(:[\d]+)?(\/([-+_~.\d\w]|%[a-fA-f\d]{2,2})*)*(\?(&?([-+_~.\d\w]|%[a-fA-f\d]{2,2})=?)*)?(#([-+_~.\d\w]|%[a-fA-f\d]{2,2})*)?/
export const CHECK_AMP = /^.*(\?|\&)amp(|\=)(|\&.*)$/
export const ONE_TURF_BASE_URL = 'https://www.oneturf.news/'
export const S3_PREFIX = process.env.REACT_APP_S3_PREFIX || 'https://media.oneturf.news/'
export const GRAPHQL_URL = process.env.REACT_APP_API_URL || 'https://gateway.api.oneturf.news/graphql'
export const GRAPHQL_INTERNAL_URL = GRAPHQL_URL
export const SUBSCRIPTION_URL = process.env.REACT_APP_SUBSCRIPTION_URL || 'wss://subscription.api.oneturf.news/graphql'
export const DOMAIN = process.env.REACT_APP_DOMAIN || 'https://www.oneturf.news/'
export const REACT_APP_ENV = process.env.REACT_APP_ENV || 'production'

export const SITE_NAME = 'Hike Sports'
export const PUBLIC_GA_TRACKING_ID = 'G-5KSV35Q65J'
// export const PUBLIC_GTM_ID = 'GTM-592XL34'
export const PUBLIC_GTM_ID = 'GTM-5FXLM844'
export const queryParamOtp = '?=otp'
export const ONLY_SPACE = /.*\S.*/
export const GLANCE_MOBILE = ['r', 'x', 's']
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.oneturf.livescore'
export const APP_STORE_URL = 'https://apps.apple.com/in/app/oneturf-live-cricket-score/id1635098414'
export const OT11_ONE_LINK_URL = 'https://oneturf11.onelink.me/nOcv/hbgkb441'
export const SB_ONE_LINK_URL = 'https://oneturf.onelink.me/gjvf/8aa6oqbi'
export const GLANCE_MOBILE_UNIT = {
  x: 'xiaomi_lp',
  r: 'Realme',
  s: 'samsung'
}

export const GOOGLE_CLIENT_ID = process.env.GOOGLE_CLIENT_ID || '164725298008-s4lm8kovm743oqb9bnqat8rhlff7emdv.apps.googleusercontent.com'
export const GOOGLE_CLIENT_SECRET = process.env.GOOGLE_CLIENT_SECRET || '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'

export const FACEBOOK_ID = process.env.FACEBOOK_ID || '733107805002126'
export const FACEBOOK_SECRET = process.env.FACEBOOK_SECRET || 'ae0d826c95a39a877e3b45db9fc7530d'

export const TRUECALLER_ID = process.env.TRUECALLER_ID || 'Ag9A84a03ddf108dd4aa1899296ffafd49142'

// Encryption key
export const PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAyLJhj3L0BOqiIEjnYLdB
gAwf4elZ7lJOqzSsllw9SuNsWv12C8GTVmAlKMbw3YKNcF2+a/DSY22UJQ3gSNT7
xWr0rhwHTsltBbyf+Rgd/OmXTxTPFMe8CfcPHk8mq4G/V+kkBINhYXPh1X74v2zK
YcKKJE/H4fZxHnnb7K8REUotOk2+1Vu0Fy+cr5obi9RKC9iMrh/gVugE16uQbi6X
XKHqo/Jri791PWN/h+wBy/EYh3feD/w5/WahuUlW7HbUmvtmEXwFjaTvf3Oj1BGs
dRmYFO2QXh4139MhwE4GBbbeLqagOrplXyrh9AmgOH8nlEYuyJf0gEggQLhdjY9M
o9PS8WQqS/v8pxl1Yd3xAb6jMwjKfVWwsSniEekW+Mgnqss1OkwUTD92a3+QDY9q
c/DmdyXayw/t4po0io6AuN/Q5Twqzof4Gvc0Nh9jwH9Ei9ywTruOADtl2TkiyEu0
0CIpliRSUoaX8NKHCYrCDGh+IX93f1NNgbchSJD8TI2QJl+/64Lw78Mta7KV0yGi
ajrlhia45HeYtfjv7cnSLpR13KHNSzGHFakgPM4REYVUJUm3rZe9CvEQvZCXEByh
aHnZB/YrTAdTGTrI1A7RSCTVjhc5mShrM9iGXcBLULlYU3DVCxfWddzi5QTkeeLD
JY5kgGKVxP5OgSXr/gT7zHUCAwEAAQ==
-----END PUBLIC KEY-----`

export const TOAST_TYPE = {
  Error: 'danger',
  Success: 'success'
}

export const DESIGNATION = [
  { label: 'Jr. Staff Writer', value: 'jsw' },
  { label: 'Sr. Staff Writer', value: 'ssw' },
  { label: 'Jr. Correspondent', value: 'jc' },
  { label: 'Sr. Correspondent', value: 'sc' },
  { label: 'Sub-Editor', value: 'se' },
  { label: 'Assistant Editor', value: 'ae' },
  { label: 'Editor', value: 'e' },
  { label: 'Sr. Editor', value: 'sre' },
  { label: 'Consulting Editor', value: 'ce' },
  { label: 'Editor-in-Chief', value: 'eic' },
  { label: 'Freelancer Writer', value: 'frw' },
  { label: 'Freelancer Correspondent', value: 'fc' },
  { label: 'Jr. Statistician', value: 'js' },
  { label: 'Sr. Statistician', value: 'ss' },
  { label: 'Guest Writer', value: 'gw' },
  { label: 'Columnist', value: 'c' },
  { label: 'Featured Writer', value: 'fw' },
  { label: 'Author', value: 'a' }
]

export const DESIGNATION_IN_JOB = [
  { label: 'Content Manager', value: 'cm' },
  { label: 'Content Writer', value: 'cw' },
  { label: 'Editor', value: 'ed' },
  { label: 'HR', value: 'hr' },
  { label: 'SEO', value: 's' },
  { label: 'Social Media', value: 'sm' },
  { label: 'Video Editor', value: 'vd' }
]

export const OPENING_IN_JOB = [
  { label: 'Work From Anywhere', value: 'wfa' },
  { label: 'Work From Home', value: 'wfh' },
  { label: 'Work From Office', value: 'wfo' }
]

export const CONTACT_EMAIL = 'contact@oneturf.com'
export const CAREER_EMAIL = 'career@oneturf.com'

export const FACEBOOK_URL = 'https://www.facebook.com/OneTurfNews'
export const LINKEDIN_URL = 'https://www.linkedin.com/company/oneturf/'
export const INSTAGRAM_URL = 'https://www.instagram.com/oneturfnews/'
export const TWITTER_URL = 'https://x.com/oneturf_news'
export const YOUTUBE_URL = 'https://www.youtube.com/@OneTurfUniverse'

export const DEFAULT_BLOG_READ = '2'
export const GOOGLE_NEWS_LINK = 'https://bit.ly/3gshIcO'
export const TELEGRAM_NEWS_LINK = 'https://ttttt.me/oneturfcom'
export const TELEGRAM_URL = 'https://bit.ly/3n0jQL6'
export const BLUR_DATA_URL = '/images/blur-image.jpg'
export const BLUR_DATA_URL_BASE64 = 'data:image/jpeg;base64,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'
export const ELEVEN_WICKETS = 'https://bit.ly/3VsKYDL'

// widget
export const WIDGET = {
  ranking: 'ranking',
  upcomingMatches: 'upcomingMatches',
  fantasyTips: 'fantasytips',
  trendingPlayers: 'trendingPlayers',
  trendingNews: 'trendingNews',
  prioritySeries: 'prioritySeries',
  topTeams: 'topTeams',
  trendingPlayer: 'trendingPlayer',
  didYouKnow: 'didYouKnow'
}

export const GENDERS = [
  { sLabel: 'Male', sValue: 'male' },
  { sLabel: 'Female', sValue: 'female' }
]

export const ROLES = [
  { sValue: 'All Rounder', sLabel: 'all' },
  { sValue: 'Batsman', sLabel: 'bat' },
  { sValue: 'Bowler', sLabel: 'bowl' },
  { sValue: 'Wicket Keeper', sLabel: 'wk' }
]
